import { createContext, useContext } from "react";

/**
 * Leaves your own pages, your profile and settings, for the page you opened them from, however
 * many of their tabs you visited. The frame remembers that page and provides this.
 */
export const LeaveYouContext = createContext<() => void>(() => {});

export function useLeaveYou() {
  return useContext(LeaveYouContext);
}
